//
//
//
//
//
//
//
//

import { Toast} from 'vue-ydui/dist/lib.rem/dialog';
import axios from 'axios';
export default {
  data() {
    return {
      styleObj: {
        height: '',
        backgroundColor:'white'
      },

      ticketNo:'',
      ticket:''
    };
  },
  methods: {

    finish(){
      axios({
        method: "POST",
        url: 'https://devlop.plian.net/web-nbcc/activity/ticket/verification', //填写接口地址  全路径
        headers: {'ticket': this.ticket,
          'module':'web-member'
        },
        data: {
          "ticketNo": this.ticketNo, //传递相关参数
        },
      }).then((res) => {
        if(res.code == 0 ){
          this.content = "使用成功";
          this.showToast(this.content,1500,'success')

        }else{
          this.content = res.message;
          this.showToast(this.content,1500,'error');
        }

      });

    },
    showToast(content,timeout,icon){
      this.$dialog.toast({
        mes: content,
        timeout: timeout,
        icon: icon,
      });
    }

  },
  mounted () {
      this.styleObj.height = $(window).height() + 'px';
    this.ticket = this.$route.query.ticket;
    this.ticketNo = this.$route.query.ticketNo;
    this.finish();
  }
};



// WEBPACK FOOTER //
// ./src/pages/whk/qr_write_off.vue